// usePurchaseOrderStampPrivileges.ts
import { useQuery } from '@apollo/client';
import { PurchaseOrderStampPrivileges } from 'purchaseOrder/list/__generated__/PurchaseOrderStampPrivileges';
import STAMP_PRIVILEGES_DATA from '../../PurchaseOrderStampPrivileges.graphql';



interface POListViewOptions {
  isSigning: boolean;
  isHistory: boolean;
  isSearchAll: boolean;
}

export function usePurchaseOrderStampPrivileges(
  POListViewOptions: POListViewOptions
) {
  const { data } = useQuery<PurchaseOrderStampPrivileges>(
    STAMP_PRIVILEGES_DATA,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-only',
    }
  );

  const stampingAllowed =
    data?.purchaseOrderStampPrivileges?.isStampingAllowed ?? false;

  const stampButtonVisible =
    stampingAllowed &&
    !POListViewOptions.isHistory &&
    !POListViewOptions.isSigning;

  return { stampingAllowed, stampButtonVisible };
}
